// Creeper override (MOB special; RED-8 power 3). PURE (ENG-1).
//
// Chases the player like a melee mob but never bites — instead it swells within
// TRIGGER_RADIUS and detonates when the fuse completes, aborting if the target
// flees past RELEASE_RADIUS. `e.fuse` (0..FUSE_TICKS) drives the client swell.
import { CREEPER, CHARGED_CREEPER } from '../../config';
import type { MobDef } from '../../registry/schemas';
import type { Entity, MobContext } from '../entity';
import { meleeAI } from '../archetypes/melee';
import { difficultyScale } from '../archetypes/shared';

export function creeper(e: Entity, def: MobDef, ctx: MobContext): void {
  meleeAI(e, def, ctx); // movement/target acquisition (no attackDamage → no bite)

  if (difficultyScale(ctx.frame.difficulty) === 0) { e.fuse = 0; return; }
  const near = ctx.sys.nearestPlayer(ctx.frame, e.x, e.y, e.z, CREEPER.RELEASE_RADIUS);
  if (near && near.dist <= CREEPER.TRIGGER_RADIUS) {
    e.fuse++;
    if (e.fuse >= CREEPER.FUSE_TICKS) {
      // A lightning-charged creeper (variant 1) detonates far harder (RED-8).
      const power = CREEPER.POWER * (e.variant === 1 ? CHARGED_CREEPER.POWER_MULT : 1);
      ctx.sys.explode(ctx.frame, e.x, e.y + 0.5, e.z, power);
      e.removed = true; // consumed by the blast (no corpse loot beyond the crater)
    }
  } else if (e.fuse > 0) {
    // Target fled the release radius → cool down the fuse.
    e.fuse = Math.max(0, e.fuse - 1);
  }
}
